export default {
  methods: {
    imgLoaded: function (e) {
      e.target.classList.add('loaded');
    }
  }
}
